<template>
  <!-- «Недавние» экрана поиска: запросы и открытые объекты одним списком по
       времени. Запрос подставляется в поле, объект открывается сразу. -->
  <section v-if="items.length" data-recents class="px-2 pb-2">
    <div class="flex items-center justify-between px-2 pt-2 pb-1">
      <h3 class="text-[11px] font-semibold text-ink2">{{ t('search.recentTitle') }}</h3>
      <button type="button" data-recents-clear class="text-[12px] font-semibold text-forest" @click="history.clear()">
        {{ t('search.clearHistory') }}
      </button>
    </div>
    <button
      v-for="e in shown"
      :key="e.type === 'query' ? `q:${e.text}` : `o:${e.kind}:${e.id}`"
      type="button"
      data-recent-row
      class="w-full flex items-center gap-2.5 px-2 py-2 rounded-md text-left hover:bg-paper2"
      @click="e.type === 'query' ? $emit('pick-query', e.text) : $emit('open-object', e)"
    >
      <component :is="iconFor(e)" class="w-4 h-4 shrink-0" :class="e.type === 'query' ? 'text-ink2' : 'text-forest'" aria-hidden="true" />
      <span class="flex-1 min-w-0">
        <span class="block text-[14px] truncate" :class="e.type === 'object' && 'font-semibold'">{{ e.type === 'query' ? e.text : e.name }}</span>
        <span v-if="e.type === 'object' && e.subtitle" class="block text-[12px] text-ink2 truncate">{{ e.subtitle }}</span>
      </span>
    </button>
    <button v-if="canExpand" type="button" data-recents-more class="px-2 py-1 text-[12px] font-semibold text-forest" @click="expanded = true">
      {{ t('search.showMore') }}
    </button>
  </section>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { Clock, Route as RouteIcon, type LucideIcon } from "lucide-vue-next";
import { kindIcon } from "../../search/kinds";
import { useSearchHistory, type HistoryEntry } from "../../composables/useSearchHistory";

type ObjectEntry = Extract<HistoryEntry, { type: "object" }>;
defineEmits<{ (e: "pick-query", text: string): void; (e: "open-object", entry: ObjectEntry): void }>();

const COLLAPSED = 5;
const EXPANDED = 10;

const { t } = useI18n();
const history = useSearchHistory();
const items = history.items;
const expanded = ref(false);
const shown = computed(() => items.value.slice(0, expanded.value ? EXPANDED : COLLAPSED));
const canExpand = computed(() => !expanded.value && items.value.length > COLLAPSED);

const iconFor = (e: HistoryEntry): LucideIcon => {
  if (e.type === "query") return Clock;
  return e.kind === "route" ? RouteIcon : kindIcon(e.osmKind ?? "");
};
</script>
